import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FirestoreService {

USERS_COLLECTION = 'users';


ADMINS_COLLECTIONS = 'admins';
COACHES_COLLECTION =  'coaches';
BANNERS_COLLECTION = 'banners';



  constructor(private firestore: AngularFirestore) {}

  getCollection(collectionName: string) {
    return this.firestore
      .collection(collectionName)
      .snapshotChanges()
      .pipe(
        map((actions) =>
          actions.map((a) => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            return { id, ...data };
          })
        )
      );
  }

  getCollectionPromise(collectionName: string){
    return this.firestore
    .collection(collectionName).get().toPromise()
  }

  addToCollection(collectionName: string, data : any) {
    return new Observable<any>((observer) => {
      const docRef = this.firestore.collection(collectionName);
      docRef.add(data).then(
        (res) => {
          console.log(res.id);
          observer.next(res);
          observer.complete();
        },
        (err) => {
          observer.error(err);
        }
      );
    });
  }

  updateDocument(collectionName : string, documentId : string, data : any){
    return new Observable<any>((observer)=>{
      const docRef = this.firestore.doc(`${collectionName}/${documentId}`);
      docRef.update(data).then(res=>{
        observer.next(true);
        observer.complete();
      }).catch(err=>{
        observer.error(err);
      })
    })
  }

  deleteDocument(collectionName : string, documentId : string){
    return new Observable<any>((observer)=>{
      const docRef = this.firestore.doc(`${collectionName}/${documentId}`);
      docRef.delete().then(res=>{
        observer.next(true);
        observer.complete();
      }).catch(err=>{
        observer.error(err);
      })
    })
  }


  getDocument(collectionName : string, documentId : string){
    return new Observable<any>((observer) => {
      const docRef = this.firestore.doc(`${collectionName}/${documentId}`);
      const userData = docRef.get().subscribe(
        (res: any) => {
          observer.next(res.data());
          observer.complete();
        },
        (err) => {
          observer.error(err);
        }
      );
    });
  }


  getDocumentAsPromise(collectionName : string, documentId : string){
    const docRef = this.firestore.doc(`${collectionName}/${documentId}`);
   return docRef.get().toPromise();
  }


  listenToDocument(collectionName, documentId){
    return this.firestore
      .doc(`${collectionName}/${documentId}`)
      .snapshotChanges()
      .pipe(
        map((changes : any) => {
          let data = changes.payload.data();
          return data;
        })
      );
  }
}
